/**
 * Minimalistic cookie utility class with static functions.
 */
export class CookieUtils {
  /**
   * Delete cookie by name.
   */
  static deleteCookie(name: string): void {
    // delete cookie by setting expired date to the past
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  /**
   * Get value from cookie by name.
   *
   * @param cookieName name of the cookie
   */
  static getCookie(cookieName: string): string {
    const name = cookieName + '=';
    const ca = document.cookie.split(';');
    for (let c of ca) {
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
}
